import { graphql } from '@api/generated/gql';

const updateUserAvailabilityStatusMutation = graphql(`
  mutation setUserAvailabilityStatus(
    $userId: ID!
    $status: UserSetAvailabilityStatus!
  ) {
    setUserAvailabilityStatus(userId: $userId, status: $status) {
      userId
      availabilityActivityStatus {
        activityStatus
        availabilityStatus
      }
      stats {
        lastActionAt
        lastHandledAt
        lastIdleAt
        loginAt
        totalSessions
        offeredSessions
        missedSessions
        avgCallTime
      }
    }
  }
`);

export default updateUserAvailabilityStatusMutation;
